import { req } from '../@api/request';

export default class RegionService {
  static list = async (code: string) => {
    const result = await req.get(`/region?code=${code}`);
    return result.data;
  };
}
